import { Page } from '../Common/Components/Page';
import { TaskManagementContent } from './Components/TaskManagementContent';

export const TaskManagement = (): React.JSX.Element => (
  <Page title="Tasks" accessKey={'tasks'} isSearchable={true}>
    <TaskManagementContent />
  </Page>
);
